export const defaultDynamicThreshold = 10;
